import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import EhsService from "../services/EhsService";
import { useQuery } from "@tanstack/react-query";

function useEhsRoleQuery(customerId: string, id: string) {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery({
    queryKey: ["ehsRole", customerId, id],
    queryFn: () => EhsService.getEhsRole(customerId, id),
    enabled: !!id,
    placeholderData: {},
    retry: false,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  const data = result.isError ? {} : result.data;

  const assignedPermissions = mapToAssignedPermissions(
    data.activePermissionMappings
  );

  return {
    ...result,
    ehsRole: data,
    assignedPermissions,
  };
}

function mapToAssignedPermissions(activePermissions: any) {
  if (!activePermissions) return [];
  return activePermissions.map((permission) => ({
    id: permission.permission.id,
    name: permission.permission.name,
    assignedQualifiers: permission.assignedQualifiers,
  }));
}

export { useEhsRoleQuery };
